module.exports = __webpack_public_path__ + "img/Vector1@2x.c593cb06.png";